<template>
  <div>
    <el-dialog title="绑定微信公众号" :visible.sync="show" width="398px" @opened="opened" @close="cancel">
      <section class="bindWeixin">
        <!-- <div id="code"> </div> -->
        <img class="qrcodeUrl" :src="qr.qrcodeUrl" alt="">
        <p class="hint">请使用微信扫描二维码</p>
      </section>
    </el-dialog>
    <el-dialog title="确定关联爱原物账号" :visible.sync="confirmShow" width="419px">
      <section class="confirmBind">
        <!-- <img :src="wxUserInfo.thirdHeadImg" alt="">
        <p>{{wxUserInfo.thirdName}}</p>
        <p class="hint">您的微信尚未关联爱原物账号</p> -->
        <div class="confirmBtn">
          <el-button type="primary" @click="bindSub">确认关联爱原物账号</el-button>
        </div>
        <div>
          <el-button plain @click="cancelBind">取消</el-button>
        </div>
      </section>
    </el-dialog>
  </div>
</template>

<script>
import { confirmBindWeixin, getWechatQrcode2, wechatPolling, appBinding } from "../../../api/accountManage";
import { mapActions } from "vuex";
export default {
  props: {
    bindWeixin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      WxObj: null,
      show: false, // 显示二维码
      confirmShow: false, // 确认绑定弹框
      wxUserInfo: {},
      wechatKey: null,
      qr: {}
    }
  },
  mounted() {
    let self = this
    window.BindBox = function (res) {
      if (res.code === 1) {
        self.wechatKey = res.data.thirdKey
        self.wxUserInfo = res.data
        self.confirmShow = true
      } else {
        self.$message({
          type: 'error',
          message: res.message
        })
        self.opened()
      }
    }
  },
  watch: {
    bindWeixin(val) {
      this.show = val
    }
  },
  destroyed() {
    //离开页面销毁
    this.clearTimeoutFun();
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    cancelBind() {
      this.confirmShow = false
      this.show = false
    },
    clearTimeoutFun() {
      clearTimeout(this.timer);
      this.timer = null;
    },
    // 打开弹框
    opened() {
      // eslint-disable-next-line no-undef
      // this.WxObj = new WxLogin({
      //   self_redirect: true,
      //   id: "code",
      //   appid: process.env.VUE_APP_APPID,
      //   scope: "snsapi_login",
      //   redirect_uri: encodeURIComponent(`${process.env.VUE_APP_WEIXIN_URL}?handlerType=bind`),
      //   state: new Date().getTime(),
      //   href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7CiAgd2lkdGg6IDE4MHB4Owp9Ci5pbXBvd2VyQm94IC50aXRsZSB7CiAgZGlzcGxheTogbm9uZTsKfQouaW1wb3dlckJveCAuaW5mbyB7CiAgd2lkdGg6IDE4MHB4Owp9Ci5zdGF0dXNfaWNvbiB7CiAgZGlzcGxheTogbm9uZTsKfQouaW1wb3dlckJveCAuc3RhdHVzIHsKICB0ZXh0LWFsaWduOiBjZW50ZXI7Cn0K"
      // })
      this.num = 0;
      getWechatQrcode2().then(res => {
        if (res.code === 1) {
          this.qr = res.data;
          this.pollingFun();
        }
      });
    },
    async pollingFun() {
      let res = await wechatPolling({
        qrcodeToken: this.qr.qrToken, // 二维码轮询key
        deviceType: 1, // 1pc,2h5,3app,4小程序，5未知设备
        clientType: 1 // 1SAAS 2IYW 3CAIHONG 4TUAN 5PORTAL
      }).catch(() => {
        this.stop();
      });
      if (res && res.code === 1) {
        if (res.data.token) { // 当token有值时，直接登录。
            this.num = -1;
            this.clearTimeoutFun();
            location.reload();
          return;
        } else if (res.data.wechatKey) { // 当wechatKey有值时代表用户扫码成功，已经获取到用户的微信信息
          appBinding(res.data.wechatKey).then(res => { // 微信公众号扫码绑定
            if (res.code === 1) {
              this.num = -1;
              this.clearTimeoutFun();
              location.reload();
            }
          })
          return;
        }
        if (this.num === -1) return;
        this.timer = setTimeout(() => {
          this.pollingFun();
        }, 800); // 轮询
      }

    },
    stop() { // 停止
      this.num = -1;
    },
    // 关闭
    cancel() {
      this.stop();
      setTimeout(() => {
        this.qr = {};
      }, 800);
      this.clearTimeoutFun();
      this.$emit("update:bindWeixin", false)
    },
    // 确认绑定微信
    async bindSub() {
      let res = await confirmBindWeixin(this.wechatKey).catch()
      if (res.code === 1) {
        this.$message({
          type: 'success',
          message: '绑定成功'
        })
        this.getUserInfo()
        this.show = false
        this.confirmShow = false
      } else {
        this.$message({
          type: 'error',
          message: res.message
        })
      }
    }
  }
}
</script>

<style lang="scss">
.bindWeixin {
  text-align: center;
  height: 300px;
  .qrcodeUrl {
    width: 215px;
    height: 215px;
  }
  #code {
    width: 200px;
    height: 200px;
    margin: 30px auto 0;
    background: #ffffff;
    border-radius: 4px;
    & > iframe {
      width: 100%;
      height: 100%;
    }
  }
  .hint {
    margin-top: 24px;
  }
}
.confirmBind {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 34px;
  img {
    width: 86px;
    height: 86px;
    border-radius: 50%;
  }
  p {
    margin-top: 13px;
  }
  .hint {
    color: $grayColor;
  }
  .confirmBtn {
    margin-top: 24px;
    margin-bottom: 18px;
  }
  .el-button {
    width: 278px;
  }
}
</style>